import { render, staticRenderFns } from "./RightPane.vue?vue&type=template&id=08c12dae"
import script from "./RightPane.ts?vue&type=script&lang=ts&external"
export * from "./RightPane.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports